import { useEffect } from 'react';

/**
 * CONSOLE FAULT 2 (27 Oct 2026, the BCBSM opt-outs of 26 Oct): a press is a run of requests, each about 6 s on a
 * Match Member, and 9 presses were lost because the page was left before they ran. While `active`, the browser asks
 * before the page is closed, reloaded or navigated away (its own wording; browsers ignore a custom one). The requests
 * already on their way are sent with keepalive (lib/care-api.ts), so this guards only the ones not started yet.
 *
 * NO em dashes (house voice rule). ASCII hyphens only.
 */
export function leaveGuard(e: BeforeUnloadEvent): void {
  e.preventDefault();
  // Older browsers show the prompt only when returnValue is set.
  e.returnValue = '';
}

export function useLeaveGuard(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    // Its own listener per caller: one shared function is registered once by the browser, so the first press to
    // finish would take the guard off another press still running (the review of 27 Oct, note 3).
    const guard = (e: BeforeUnloadEvent) => leaveGuard(e);
    window.addEventListener('beforeunload', guard);
    return () => window.removeEventListener('beforeunload', guard);
  }, [active]);
}
